const defaultShortDomainName = 'pro';
const defaultFullDomainName = `tutorium.${defaultShortDomainName}`;

export const getFullDomainName = () => {
  try {
    const result = window.location.host.slice(4);

    return result.includes('vip') ? `tutorium.vip` : defaultFullDomainName;
  } catch {
    return defaultFullDomainName;
  }
};

export const getShortDomainName = () => {
  try {
    const result = window.location.host;

    return result.includes('vip') ? 'vip' : defaultShortDomainName;
  } catch {
    return defaultShortDomainName;
  }
};

export const getInfoEmailAddress = () => `info@${getFullDomainName()}`;
